import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { OffersLabelComponent } from '~shared/components/offers-label/offers-label.component';
import { DelayedHoverModule } from '~shared/directives/delayed-hover/delayed-hover.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    QaLocatorsModule,
    DelayedHoverModule
  ],
  declarations: [
    OffersLabelComponent,
  ],
  exports: [
    OffersLabelComponent
  ]
})

export class OffersLabelModule {}
